import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, first, from, of } from "rxjs";
import { eContracts } from "../contract.config";
import { eCurrencies } from "app/common/ui/info-icon/info-icon.interface";
import { getCurrencyContract } from "app/services/companyItems/company-items.interface";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";


@Injectable({
    providedIn: 'root'
})
export class NFTItemService {

    public contract: any
    //public contractNFTItems:any
    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service,
        private http: HttpClient
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.KMONFTV2);
        // this.contractsService.getContractIstances(eContracts.KMONFTV2).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract(eContracts.NFTItems);
    }

    //Maybe is a boolean
    isApprovalForAll(ownerAddress: string, operatorAddress: string): Observable<any> {
        return from(this.contract.methods.isApprovedForAll(ownerAddress, operatorAddress).call());
    }

    setApprovalForAll(ownerAddress: string, operatorAddress: string, approved: boolean): Observable<any> {
        return from(this.contract.methods.setApprovalForAll(operatorAddress, approved).send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

    safeBatchTransferFrom(fromAddress: string, receiverAddress: string, ids: string[], values: number[], data: any): Observable<any> {
        return from(this.contract.methods.safeBatchTransferFrom(fromAddress, receiverAddress, ids, values, data)
            .send({ ...this.contractsService.additionalParameters(), from: fromAddress }));
    }

    buyItem(ownerAddress: string, boxId: string, amount: number, currency: eCurrencies, price?: number): Observable<any> {
        if (currency === eCurrencies.CANDIES) {
            return from(this.contract.methods.purchaseItemsWithCandies(ownerAddress, [boxId], [amount]).send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
        } else {
            let _currency = eContracts[currency];
            let currencyAddress: string = this.contractsService.getContractAddress(_currency);
            return from(this.contract.methods.purchaseItems(ownerAddress, [boxId], [amount], currencyAddress).send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
        }
    }

    getUpgradeItemsDefinitions(): Observable<any> {
        return from(this.contract.methods.getUpgradeItemsDefinitions().call())
    }

    getAllPurchasableItems(): Observable<any> {
        return from(this.contract.methods.getAllPurchasableItems().call())
    }

    upgradeItem(ownerAddress: string, itemUpgradeId: string, mainItemId: string, materialIds: string[], materialQuantities: string[]): Observable<any> {
        return from(this.contract.methods.upgradeItem(
            itemUpgradeId,
            mainItemId,
            materialIds,
            materialQuantities
        )
            .send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

    getItemTypes(itemIds: string[]): Observable<any> {
        return from(this.contract.methods.getItemTypes(itemIds).call());
    }

}